import { QuizDiagnosticsChapter, QuizDiagnosticsTagColor } from '../types'

export type ChapterFilterOption = {
  label: string
  value: string
  tag?: string
  order?: number
  title?: string
  tag_colour?: QuizDiagnosticsTagColor
}

export const buildChapterFilterOptions = (
  chapters: QuizDiagnosticsChapter[] = []
): ChapterFilterOption[] =>
  chapters.map(chapter => ({
    label: `${chapter.tag} ${chapter.order}. ${chapter.title}`,
    value: chapter.id,
    tag: chapter.tag,
    order: chapter.order,
    title: chapter.title,
    tag_colour: chapter.tag_colour
  }))

export const getSafeChapterFilterValue = (
  selectedChapterId: string,
  filterOptions: ChapterFilterOption[]
) => {
  const selectedOption = filterOptions.find(
    option => option.value === selectedChapterId
  )

  if (selectedOption) {
    return selectedOption
  }

  return filterOptions?.find(option => option.value === 'all') ?? null
}

export const getChapterTagLabel = (option: ChapterFilterOption): string =>
  `${option?.tag ?? ''} ${option?.order ?? ''}`.trim()
